import { medicareApiClient } from 'clients/medicareApiClient'
import { IActivityType } from 'models/Analytics'
import events, { Event, Subscriber } from 'pubsub/events'

export interface SiteActivityRecord {
  url: string;
  property: string;
  title: string;
  language: string;
  authenticated: boolean;
  activity: IActivityType;
  component?: string; // TODO: Determine if we want to type check this or set it automatically
  data: CoreClickData;
}

export interface CoreClickData {
  linkText?: string;
  linkUrl?: string;
  messageId?: string;
  profileId?: string;
  modalType?: string;
}
export const isCoreClickData = (coreClickData: any): coreClickData is CoreClickData => (
  (
    typeof (coreClickData.linkText) === 'string' ||
    typeof (coreClickData.linkText) === 'undefined'
  ) &&
  (
    typeof (coreClickData.linkUrl) === 'string' ||
    typeof (coreClickData.linkUrl) === 'undefined'
  )
)

let subscription: Subscriber

export const startListening = () => {
  subscription = events.subscribe({
    next: (event: Event) => {
      const shouldSendToCoreAPI = event.sendToCoreAPI
      if (shouldSendToCoreAPI) {
        const coreAPIEvent: SiteActivityRecord = {
          url: event.url,
          property: event.property ?? 'MAX',
          title: event.title,
          language: event.language,
          authenticated: event.authenticated,
          activity: event.activity,
          component: event.component ?? 'Header',
          data: {
            linkText: event.text, // optional, only needed for link clicks
            linkUrl: event.targetLocation || '', // optional, only needed for link clicks
            messageId: event.messageId ?? event.core?.messageId, // only for message read and message open activity
            profileId: event.profileId ?? event.core?.profileId // only for message read and message open activity
          }

        }
        sendCoreAPIEvent(coreAPIEvent)
      }
    },
    error: (error) => {
      console.log('error:', error)
    },
    complete: () => {
      console.log('complete')
    }
  })
}

export const unsubscribe = () => {
  subscription.unsubscribe()
}

export const sendCoreAPIEvent = async (event: SiteActivityRecord) => {
  const payload = {
    siteActivity: event
  }

  try {
    await medicareApiClient.asyncPostSiteActivity(payload)
  } catch (error) {
    console.log('Error sending siteActivity to CoreAPI')
  }
}
